var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreVertical = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "13 7 3 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 8.6c0-.884.71-1.6 1.6-1.6.884 0 1.6.71 1.6 1.6 0 .884-.71 1.6-1.6 1.6-.884 0-1.6-.71-1.6-1.6m0 6.4c0-.884.71-1.6 1.6-1.6.884 0 1.6.71 1.6 1.6 0 .884-.71 1.6-1.6 1.6-.884 0-1.6-.71-1.6-1.6m0 6.4c0-.884.71-1.6 1.6-1.6.884 0 1.6.71 1.6 1.6 0 .884-.71 1.6-1.6 1.6-.884 0-1.6-.71-1.6-1.6"
})));
export default SvgMoreVertical;